module.exports = "<div class=\"row\">\n    <div class=\"col-md-11\">\n        <div class=\"commentThread\">\n            <div class=\"eventBody\" ng-if=\"$ctrl.event.isRichText\" ng-bind-html=\"$ctrl.unescape()\"></div>\n            <div class=\"eventBody whitespace\" ng-if=\"!$ctrl.event.isRichText\">{{$ctrl.event.body}}</div>\n            <span class=\"fontGrey\" ng-if=\"$ctrl.event.createdDate\"> - {{$ctrl.event.createdDate | datetime}}</span>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./modules/support/components/support-feed-event/supportFeedEvent.component.html
// module id = 748
// module chunks = 0